<p-dialog #vetDetailsDialog header="{{entityType}} Vet Results for {{entityName}} from {{vetDate | date: 'M/d/yyyy' }}" [closable]="false" [modal]="true" [visible]="true"
  [style]="{width: '600'}" [focusOnShow]="false">

  <div class="results">
    @if (findings) {
    @for (finding of findings; track finding) {
    <p class="compress">{{finding}}</p>
    }
    }
    @else if (errorDescription) {
      <p>
        {{errorDescription}}
      </p>
      }
    @else {
      <p>
        No Results Available
      </p>
    }
  </div>

  <p-footer>
    <button i18n id="vetResultsOk" class="btn btn-primary" (click)="close()">OK</button>
  </p-footer>
</p-dialog>